import React, { useRef, useState } from 'react'
import "./Contact.css"

const Contact = () => {

    const form = useRef();

    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [services, setServices] = useState("");
    const [date, setDate] = useState("");
    const [errors, setErrors] = useState({});


    const loginHandle = (e) => {
        e.preventDefault();

        const errors = validateForm();

        if (Object.keys(errors).length === 0) {
            errors.name = "";
            errors.phone = "";
            errors.services = "";
            errors.date = "";

            var url = "https://wa.me/9921589794?text=" +
                " Your Name:" + name +
                " Your Phone : " + phone +
                " Services : " + services +
                " Date : " + date;

            window.open(url, '_blank').focus();

        }

        else {
            setErrors(errors);
        }
        setName("");
        setPhone("");
        setServices("");
        setDate("");

    }

    const validateForm = () => {
        const errors = {};

        if (!name) {
            errors.name = "Names Is Requried";
        }
        else if (name.length < 4) {
            errors.name = "Names Requried At Least Four Characters"
        }
        if (!phone) {
            errors.phone = "Phone Number is Requried";
        }
        if (!services) {
            errors.services = "Please Select Services";
        }
        if (!date) {
            errors.date = "Please Select Date";
        }



        return errors;

    }



    return (
        <>

            <section id='contact'>
                <div className="container-fluid">
                    <div className='CommonPadding'>
                        <div className="row d-flex justify-content-center align-items-center Organic-Food-Section-Main-Heading-Top">
                            <div className='Home-Our-Services-Section-Title'>
                                <h5>
                                    Contact Us
                                </h5>
                                <h2>
                                    Our salon offers a wide variety of beauty services
                                </h2>
                            </div>
                        </div>

                        <div className="row g-4">
                            <div className="Home-Contact-Map">
                                <iframe className='w-100 h-100' style={{ borderRadius: "8px" }} title="gmap" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.4112307665055!2d73.85008907465189!3d18.510309769488682!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c1c080aa3e1f%3A0x3ea43d560d8903cf!2sP.%20A.%20S.%20Glam%20Beauty%20Studio%20%26%20Institute.!5e0!3m2!1sen!2sin!4v1764865347557!5m2!1sen!2sin">
                                </iframe>
                            </div>
                        </div>

                        <div className="row d-flex justify-content-lg-center g-4 position-relative pb-5 mb-5" style={{ borderBottom: "1px solid #e1e7ec" }}>
                            <div className="col-xl-4 col-lg-6 col-md-6">
                                <div className='Home-Contact-Top'>
                                    <div className='Home-Contact-Top-Sub-First'>
                                        <i className='fa fa-map-marker '></i>
                                    </div>

                                    <div className='Home-Contact-Top-Sub-Second'>
                                        <h4>
                                            Our Shop
                                        </h4>
                                        <h5>
                                            SHOP NO 1, Atharva Niwas, near Durga Mata Mandir,
                                            opp. to Kokan Katta Khanaval,
                                            Shriram Nagar, Dhankawadi, Pune, Maharashtra 411046
                                        </h5>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-4 col-lg-6 col-md-6">
                                <div className='Home-Contact-Top'>
                                    <div className='Home-Contact-Top-Sub-First'>
                                        <i className='fa fa-clock '></i>
                                    </div>

                                    <div className='Home-Contact-Top-Sub-Second'>
                                        <h4>
                                            Opening Hours
                                        </h4>
                                        <h5>
                                            Mon – Sun : 11:00 AM to 8:00 PM
                                        </h5>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-4 col-lg-6 col-md-6">
                                <div className='Home-Contact-Top'>
                                    <div className='Home-Contact-Top-Sub-First'>
                                        <i className='fa fa-phone '></i>
                                    </div>

                                    <div className='Home-Contact-Top-Sub-Second'>
                                        <h4>
                                            Get In Touch
                                        </h4>


                                        <h5>
                                            <a href="tel:9921589794" className='text-decoration-none'>
                                                9921589794
                                            </a>
                                            <br />
                                            <a href="tel:9022465871" className='text-decoration-none'>
                                                9022465871
                                            </a>
                                            <br />
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-8 col-md-12">
                                <div className='MontserratFont mt-3 mb-4'>
                                    <h2 className='' style={{ fontWeight: "600" }}>
                                        Make An Appointment
                                    </h2>
                                    <p>

                                    </p>
                                </div>
                                <div className='Home-Contact-Form MontserratFont'>
                                    <form ref={form} onSubmit={loginHandle} className="row g-4 ">
                                        <div className="col-lg-6 col-md-6">
                                            <label htmlFor="" className='LabelCommon'>Your Name</label>
                                            <input type="text" className="form-control CommonInput" id="inputName" name="name"
                                                onChange={e => setName(e.target.value)} value={name}
                                            />
                                            {errors.name && <div className='CommonErrors' >{errors.name}</div>}
                                        </div>

                                        <div className="col-lg-6 col-md-6">
                                            <label htmlFor="" className='LabelCommon'>Your Phone</label>
                                            <input type="text" className="form-control CommonInput" id="inputName" name="name"
                                                onChange={e => setPhone(e.target.value)} value={phone}
                                            />
                                            {errors.phone && <div className='CommonErrors'>{errors.phone}</div>}
                                        </div>

                                        <div className="col-lg-6 col-md-6">
                                            <label htmlFor="" className='LabelCommon'> Services</label>
                                            <div class="custome-select">
                                                <select
                                                    onChange={e => setServices(e.target.value)} value={services}>
                                                    <option>Facials</option>
                                                    <option>Eyebrow & Eyelashes</option>
                                                    <option>Wash</option>
                                                    <option>Cut & Finish</option>
                                                    <option>Blow Dries</option>
                                                    <option>Hair Colouring</option>
                                                </select>
                                            </div>

                                        </div>

                                        <div className="col-lg-6 col-md-6">
                                            <label htmlFor="" className='LabelCommon'> Appointment Date</label>
                                            <input type="date" className="form-control CommonInput" id="inputName" name="name"
                                                onChange={e => setDate(e.target.value)} value={date}
                                            />
                                            {errors.date && <div className='CommonErrors'>{errors.date}</div>}
                                        </div>

                                        <div className="col-lg-12 mt-lg-2">
                                            <div className='d-flex justify-content-start mb-3 ContactSubmit'>
                                                <button type="submit" className="">
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >

        </>
    )
}

export default Contact